import type { Property } from '~/core/entities/property';

import { ShortsJsonLdPresenter } from '~/presenters/ShortsJsonLdPresenter';

export function useShortsVideoJsonLd(
	propertyGetter: () => Property | null | undefined
) {
	const websiteUrl = useRuntimeConfig().public.ORIGIN;
	const property = computed(propertyGetter);

	const shortsVideoJsonLd = computed(() =>
		ShortsJsonLdPresenter.getShortsVideoJsonLd({
			property: property.value,
			websiteUrl
		})
	);

	useJsonld(() => shortsVideoJsonLd.value);
}
